export const bookingsHc = {
  firstCheckinSend: {
    badge: "الأتمتة",
    title: "متى تُرسل معلومات الوصول؟",
    desc: "فعّل كل حدث وقرّر <strong>متى</strong> يُرسل: عندما يُكمل <strong>نزيل واحد</strong> تسجيله، أو فقط عندما يُكمل <strong>جميع</strong> نزلاء الحجز تسجيلهم.",
    loading: "جارٍ تحميل الإعدادات…",
    welcomeName: "رسالة الترحيب",
    welcomeSub: "رسالة الترحيب التي يتلقاها النزيل فور إكمال تسجيله.",
    documentName: "وثيقة السياسات الموقّعة",
    documentSub: "هي الوثيقة التي يوقّعها النزيل أثناء عملية التسجيل. نرسلها بصيغة PDF ليحتفظ بها على واتساب أو البريد الإلكتروني.",
    timingIndividual: "عندما يُكمل نزيل تسجيله",
    timingAll: "عندما يُكمل جميع نزلاء الحجز التسجيل",
    timingQuestion: "متى يُرسل؟",
    eventOffNote: "لن يُرسل هذا الحدث تلقائيًا.",
    infoBox: "تُحفظ التغييرات تلقائيًا. أما مفتاح الدخول، عندما يكون لدى مكان الإقامة قفل ذكي، فيتبع إعداداته الخاصة.",
    loadError: "تعذّر تحميل الإعدادات.",
    saveError: "تعذّر حفظ الإعدادات. حاول مرة أخرى.",
  },
  checkinProcess: {
    colEmail: "البريد الإلكتروني",
    colSendDate: "تاريخ الإرسال",
    colStatus: "الحالة",
    unspecified: "غير محدد",
    complete: "مكتمل",
    pending: "قيد الانتظار",
  },
  listBookings: {
    title: "قائمة تسجيلات الوصول",
    subtitle: "سجل تسجيلات وصول نزلائك",
    accommodation: "مكان الإقامة",
    all: "الكل",
    from: "من",
    to: "إلى",
    search: "بحث",
    today: "اليوم",
    noDate: "بدون تاريخ",
    clear: "مسح",
    exporting: "جارٍ التصدير...",
    exportCheckins: "تصدير",
    ricevutaBtn: "إيصال الشرطة",
    ricevutaTitle: "إيصال الشرطة الإيطالية",
    ricevutaHint: "الإيصال الرسمي من Alloggiati Web بجميع تسجيلات الوصول المرسلة كل يوم. يوم واحد ينزّل ملف PDF؛ وعدة أيام ملف ZIP بملف PDF لكل يوم (31 كحد أقصى).",
    ricevutaFrom: "من",
    ricevutaTo: "إلى",
    ricevutaAccount: "حساب الشرطة",
    ricevutaDownload: "تنزيل PDF",
    ricevutaDownloading: "جارٍ التنزيل…",
    ricevutaCancel: "إلغاء",
    ricevutaError: "تعذر تنزيل الإيصال.",
    noAccommodation: "بدون مكان إقامة",
    noReservation: "بدون حجز",
    travelerReport: "تقرير المسافر (Mossos)",
    noRecords: "لا توجد سجلات",
    noRecordsFiltered: "لم يتم العثور على سجلات بالفلاتر المطبقة.",
    noCheckinsTitle: "لا توجد تسجيلات وصول بعد",
    noCheckinsSub: "عندما يُكمل نزلاؤك تسجيل الوصول، ستراهم هنا مع جميع معلوماتهم.",
    excelSuccess: "تم تنزيل تسجيلات الوصول إلى Excel",
    excelSuccessTitle: "اكتمل التصدير",
    excelError: "تعذّر علينا تصدير تسجيلات الوصول",
    errorTitle: "خطأ",
    listingNotIdentified: "تعذّر تحديد إعلان تسجيل الوصول",
    comprobanteNotAvailable: "الإيصال غير متاح بعد لتسجيل الوصول هذا",
    comprobanteDownloadError: "تعذّر تنزيل الإيصال",
  },
  modalFirstCheckin: {
    loading: "جارٍ التحميل...",
    sendingLinkWait: "جارٍ إرسال رابط تسجيل الوصول، يرجى الانتظار...",
    phoneRequired: "للمتابعة يجب إدخال رقم واتساب",
    sendingLink: "جارٍ إرسال الرابط ...",
    almostThere: "بقي القليل، يرجى الانتظار...",
    sentSuccess: "تم الإرسال بنجاح",
    sendError: "خطأ أثناء إرسال تسجيل الوصول",
    title: "جرّب الآن عملية تسجيل وصول باستخدام هاتفك الخاص",
    enterWhatsapp: "أدخل رقم واتساب الخاص بك",
    invalidNumber: `رقم غير صالح. تأكد من تضمين البادئة "+".`,
    skip: "تخطي",
    sendFirstCheckin: "أرسل أول تسجيل وصول لك",
    sendCheckin: "أرسل تسجيل الوصول",
  },
  tableRetriveCheckinPending: {
    colEmail: "البريد الإلكتروني",
    colSendDate: "تاريخ الإرسال",
    colStatus: "الحالة",
    unspecified: "غير محدد",
    complete: "مكتمل",
    pending: "قيد الانتظار",
    emptyMessage: "ليس لديك أي تسجيلات وصول قيد المعالجة بعد",
  },
  rerservationModal: {
    night: "ليلة",
    nights: "ليالي",
    minStayBanner: "النطاق المحدد لديه قيد إقامة دنيا قدرها {count} {nights} (قاعدة OTA). الليالي المحددة: {selected}.",
    freeUnits: "الوحدات المتاحة: {count}",
    noAvailabilityDetailed: "لا يوجد توفر لهذه التواريخ. {details}",
    noAvailability: "لا يوجد توفر لهذه التواريخ.",
    hotelAvailabilityError: "تعذّر التحقق من التوفر (فندق).",
    minStayWarning: "يلزم حد أدنى {count} ليالي ليوم الوصول. لقد اخترت {selected}.",
    notEnoughAvailability: "لا يوجد توفر كافٍ. الوحدات المتاحة: {count}.",
    noAvailabilityDates: "لا يوجد توفر للتواريخ المحددة.",
    departureAfterArrival: "يجب أن يكون تاريخ المغادرة بعد تاريخ الوصول.",
    close: "إغلاق",
    noMatches: "لا توجد تطابقات",
    noAccommodations: "لا توجد أماكن إقامة",
    searchingGuests: "جارٍ البحث عن النزلاء...",
    noName: "بدون اسم",
    priceLocked: "لا يمكن تعديل سعر الحجز.",
    otaMoveHint: "يمكنك نقله إلى مكان إقامة آخر في نفس الإعلان؛ يتم إبلاغ القناة.",
    otaMoveHintCuenta: "يمكنك نقلها إلى أي من أماكن الإقامة الخاصة بك. إذا كانت في نفس الإعلان، يتم إبلاغ القناة.",
    otaRelocateNote: "هذا إعلان آخر: يتم نقلها في WACheckin، لكن القناة ستبقيها في مكان الإقامة الذي بيعت فيه. ستستمر في تلقي تعديلاتها وإلغائها.",
    extrasTitle: "خيارات أخرى",
    extrasSub: "حدّد ما تُحصّله والخصم الذي تطبّقه",
    quoteTitle: "ما تتقاضاه حجوزاتك المباشرة",
    quoteHint: "حدّد ما تريد تحصيله في هذا الحجز. الليالي محتسبة دائمًا.",
    quoteOptions: "عنصر واحد للتحديد | {count} عناصر للتحديد",
    quoteNoExtras: "لا توجد رسوم تنظيف أو رسوم أخرى مهيأة في الحجز المباشر لمكان الإقامة هذا.",
    quoteStay: "الإقامة · {count} ليلة | الإقامة · {count} ليالٍ",
    quoteExtraGuest: "ضيف إضافي | {count} ضيوف إضافيون",
    quoteDiscount: "الخصومات والعروض",
    quoteOccupancyDiscount: "خصم حسب الإشغال",
    quoteCleaning: "رسوم التنظيف",
    quoteTotal: "الإجمالي",
    quoteUse: "استخدم هذا السعر",
    quoteNoRate: "لا توجد تسعيرة لتلك التواريخ: اكتب السعر يدويًا.",
    quoteLinePrice: "سعر هذا المكان",
    unitsAdd: "أضف مكان إقامة آخر من الإعلان…",
    unitsGuests: "الضيوف في مكان الإقامة هذا",
    unitsRemove: "إزالة من الحجز",
    unitsGroupError: "تعذر إنشاء حجز بعدة أماكن إقامة.",
    resendTitle: "إعادة إرسال رسالة التأكيد",
    resendSub: "يعيد إرسال قالب التأكيد إلى النزيل.",
    resendNote: "عند تعديل الحجز، <strong>سيُعاد إرسال قالب التأكيد</strong> لهذا الحجز.",
    saving: "جارٍ الحفظ...",
  },
};
